import React, { useRef, useState } from 'react'
import { uploadFile } from '../../../apis/messageListApi';
import { Button, Spinner } from "@fluentui/react-components"

import './fileUploader.scss'

interface IFileUploaderProps {
    url: string,
    onSuccess: (response: string) => void,
    onError?: (response?: Error) => void,
    buttonIcon: any,
    buttonText: string,
    acceptedFileTypes: string,
    disabled?: boolean,
    baseServiceUrl?: string,
}


const FileUploader: React.FC<IFileUploaderProps> = (props: IFileUploaderProps) => {
    const imageAttachmentButtonRef: React.RefObject<any> = useRef();
    const [ fileUploadInProgress, setfileUploadInProgress ] = useState(false);
    const [ fileUploadError, setFileUploadError ] = useState<string | undefined>(undefined);

    const uploadFileMiddleware = async (event: React.ChangeEvent<HTMLInputElement>) => {
        event?.preventDefault();
        setFileUploadError(undefined)
        if (event?.target === null || event.target.value.length === 0 || event.target.files === null) {
            return;
        }
    
        setfileUploadInProgress(true);
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("formFile", file);
    
        try {
            let response = await uploadFile(props.url, formData, props.baseServiceUrl);
            props.onSuccess && props.onSuccess(response);
        } catch (e) {
            setFileUploadError("Failed to upload file")
            props.onError && props.onError(e as Error);
        } finally {
            setfileUploadInProgress(false);
        }
    
    }

    return (
        <div className="fileUploader">
            <input type="file" ref={imageAttachmentButtonRef} name="file" accept={props.acceptedFileTypes} onChange={uploadFileMiddleware} onClick={ (event: any) => event.target.value = null} style={{ display: "none" }} />
            <Button onClick={(event: any) => { event?.preventDefault(); imageAttachmentButtonRef?.current?.click(); }} disabled={props.disabled} icon={props.buttonIcon} appearance='primary' color="accent" >{props.buttonText}</Button>
            {fileUploadInProgress && <Spinner size="extra-small" label={"Uploading..."} labelPosition="after" />}
            {fileUploadError && (<p className="fileUplaoder__error">Failed to upload file</p>)}
        </div>
    )
}

export default FileUploader;